/**
 * useJourneySpineStatus (P274) -- the lifecycle-journey spine.
 *
 * The permanent, complete companion to the P106 Getting Started ladder:
 * the bank's position along the 9-stage data lifecycle. Bank-level +
 * cheap; cached a few minutes like the onboarding status.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import { journeySpineKeys } from "shared/api/queryClient";
import type { JourneySpineStatus } from "shared/api/types";

export function useJourneySpineStatus(): UseQueryResult<JourneySpineStatus, ApiError> {
  return useQuery({
    queryKey: journeySpineKeys.all,
    queryFn: () => api.get<JourneySpineStatus>("/v1/journey/status"),
    // Round 14 F2 -- a connector can start failing without anyone
    // writing anything, so this cannot wait two minutes to notice.
    staleTime: 30_000,
  });
}
